const ITEM_HEIGHT=48;// Core component styles
const coreStyles={container:{maxHeight:"".concat(ITEM_HEIGHT*8.5,"px")}};/**
 * Helper method to get styles for the Menu Component
 * @param {Object} contextStyles - Custom styles for the Menu component
 */const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{container:{...coreStyles.container,...contextStyles.container}};};export default getStyles;